import {Component, ContentChild, EventEmitter, Host, Input, Optional, Output} from '@angular/core';
import {DropdownComponent} from "../dropdown/dropdown.component";
import {IconDirective} from "../../../directives/icon/icon.directive";

@Component({
  selector: 'cqme-dropdown-item',
  standalone: true,
  imports: [],
  templateUrl: './dropdown-item.component.html',
  styleUrl: './dropdown-item.component.scss',
})
export class DropdownItemComponent {
  @Input() label: string = "";
  @Output() click = new EventEmitter<MouseEvent>();

  @ContentChild(IconDirective) icon?: IconDirective;

  constructor(@Host() @Optional() private dropdown: DropdownComponent | null) {
  }

  get hasIcon(): boolean {
    return !!this.icon;
  }

  handleClick(event: MouseEvent) {
    this.click.emit(event);
    this.dropdown?.close();
  }
}
